import axios from "axios";
export async function passwordChangeSubmitFunc(e, setIsFormSubmitButtonClicked, isFormSubmitButtonClicked, currentPasswordErrorState, newPasswordErrorState, reNewPasswordErrorState, setIsFormSubmitted, changePasswordVal, setErrorFromServer, setChangePasswordVal, setIsPopupOpened) {

        setIsFormSubmitButtonClicked(true);
        e.preventDefault();
    
        if(isFormSubmitButtonClicked) {
    
        if(currentPasswordErrorState == false && newPasswordErrorState == false && reNewPasswordErrorState == false) {
    
          setIsFormSubmitted(true);
    
          try {
            const { data } = await axios.post(
              "https://salesforceb2b.customers.bigfivecrm.com/changePassword",
              {
                ...changePasswordVal,
              },
              { withCredentials: true }
            );
            
            const { success, message, isLoggedIn } = data;
            sessionStorage.setItem("userName", data.user_name);
            document.cookie = `isLoggedIn=${isLoggedIn}; path=/`;
            if(isLoggedIn) {
              sessionStorage.setItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf", "fsfkDG73DGFDGE&^FDHd!@fJHG2334T");
              setIsFormSubmitted(false);
            } else {
              sessionStorage.setItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf", "DSFSDhew234%*dgffd126DR3$%sDFGF");
              console.log(message);
              setIsFormSubmitted(false);
            }
            if(message == "Current password is wrong!") {
              setErrorFromServer("Current password is wrong!");
            }
            if (success) {
              setTimeout(() => {
                setChangePasswordVal({
                  currentPassword: "",
                  newPassword: "",
                  reNewPassword: ""
                });
                setIsFormSubmitButtonClicked(false);
                setIsPopupOpened(false);
              }, 100);
            }
          } catch (error) {
            console.log(error);
          }
    
        }
      }
    
}